const metalRoofing = [
  {
    question: "What are metal roofs made of?",
    answer:
      "Metal roofs are typically made from steel, aluminum, zinc, or copper. These materials are prized for durability, corrosion resistance, and long lifespans — especially in California climates<IN_CITY_ZIP>.",
  },
  {
    question: "How long does a metal roof last?",
    answer:
      "A properly installed metal roof<IN_CITY_ZIP> can last 40 to 70 years depending on the material and maintenance. It's one of the most durable roofing solutions available.",
  },
  {
    question: "Do I need a permit to install or replace a metal roof?",
    answer:
      "Yes. Metal roofing installations require city permits and inspections. Modern Build manages the entire permitting process to ensure full compliance with local codes<IN_CITY_ZIP>.",
  },
  {
    question: "How long does it take to install a metal roof?",
    answer:
      "Most metal roof installations<IN_CITY_ZIP> take between 4 to 8 days, depending on roof complexity, size, and weather. We’ll provide a detailed timeline tailored to your project.",
  },
  {
    question: "Are metal roofs good for hot climates?",
    answer:
      "Yes. Metal roofs reflect solar heat and reduce indoor temperatures, making them ideal for hot climates<IN_CITY_ZIP>. Cool roof coatings further enhance energy efficiency.",
  },
  {
    question: "What types of metal roofs do you install?",
    answer:
      "We install standing seam, corrugated, ribbed panels, and metal shingles<IN_CITY_ZIP>. Each can be color-matched or coated for energy savings and curb appeal.",
  },
  {
    question: "Can a metal roof be installed over an existing roof?",
    answer:
      "Sometimes. Metal roofs can be installed over asphalt shingles if the structure meets code and load requirements<IN_CITY_ZIP>. We’ll evaluate your roof and recommend the safest approach.",
  },
  {
    question: "Do metal roofs make noise in the rain?",
    answer:
      "No. When installed with proper underlayment and insulation, metal roofs are no louder than other roofing systems during rainstorms<IN_CITY_ZIP>. Most homeowners notice no difference in sound.",
  },
  {
    question: "How much does a metal roof cost?",
    answer:
      "Metal roofing typically ranges from $12,000 to $30,000+, depending on material, roof size, slope, and labor. We provide transparent estimates customized to your needs.",
  },
  {
    question: "Are warranties available on metal roofing systems?",
    answer:
      "Yes. Our metal roofs<IN_CITY_ZIP> come with manufacturer warranties of up to 40 years, plus Modern Build’s workmanship guarantee for added peace of mind.",
  },
];

export default metalRoofing;
